import { SummaryFooter } from '@com-delta-idp/mnx-skymiles-overview-ui';
import { DefaultTooltip } from '../models';

export const getFooterDetails = (
  label: string,
  info: string
): SummaryFooter => {
  return {
    label,
    tooltip: {
      background: DefaultTooltip.background,
      color: DefaultTooltip.color,
      hideCloseIcon: false,
      info,
      position: DefaultTooltip.position,
      hover: false
    }
  };
};
